module.exports = __webpack_public_path__ + "img/footer-img.2c56e104.png";